import React, { useEffect, useState, useContext } from "react";
import { CircularProgress, Card, Pagination } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import StaySearch from "./StaySearch";
import CreateDomesticStayReq from "../../../Classes/Models/Requests/Accounting/CreateDomesticStayReq";
import AccountingApi from "../../../Classes/API/AccountingApi";
import DataTable from "examples/Tables/DataTable";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { LanguageContext } from "App";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Loader from "Loader";
const Index = () => {
  let navigate = useNavigate();
  const { translations } = useContext(LanguageContext);

  const [SearchReq, setSearchReq] = useState(new CreateDomesticStayReq());
  const [ResponseData, setResponseData] = useState({});
  const [IsLoaded, setIsLoaded] = useState(false);
  const [TableDataRows, setTableDataRows] = useState([]);
  const [Page, setPage] = useState(1);
  const [TotalPages, setTotalPages] = useState(0);

  const TableColumns = [
    { Header: translations.sessionWithoutEnteriesid, accessor: "Id", align: "left" },
    { Header: translations.PatientStaytablePatient, accessor: "Patient", align: "left" },
    { Header: translations.CreateDomesticStayRoomType, accessor: "RoomType", align: "left" },
    { Header: translations.CreateDomesticStayRoomId, accessor: "RoomId", align: "left" },
    { Header: translations.PatientStaytableStartDate, accessor: "StartDate", align: "left" },
    { Header: translations.PatientStaytableEndDate, accessor: "EndDate", align: "left" },
    {
      Header: translations.PatientStaytableNumberOfDays,
      accessor: "NumberOfDays",
      align: "center",
    },
    { Header: translations.PatientStaytablePrice, accessor: "Price", align: "center" },
    {
      Header: translations.PatientStaytableInsurancePrice,
      accessor: "InsurancePrice",
      align: "center",
    },
    { Header: translations.CreateDomesticStayNotes, accessor: "Notes", align: "left" },
    { Header: translations.PatientStaytableDetails, accessor: "Details", align: "left" },
  ];

  const MakeTableRow = (Stay) => {
    return {
      Id: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Stay.id}
        </MDTypography>
      ),
      Patient: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Stay.getPatient.getUser.name}
        </MDTypography>
      ),
      RoomType: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Stay.roomType}
        </MDTypography>
      ),
      RoomId: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Stay.roomId}
        </MDTypography>
      ),
      StartDate: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Stay.startDate}
        </MDTypography>
      ),
      EndDate: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Stay.endDate}
        </MDTypography>
      ),
      NumberOfDays: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Stay.numberOfDays}
        </MDTypography>
      ),
      Price: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Stay.price} EGP
        </MDTypography>
      ),
      InsurancePrice: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Stay.insurancePrice} EGP
        </MDTypography>
      ),
      Notes: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Stay.notes}
        </MDTypography>
      ),
      Details: (
        <button
          className="btn btn-primary"
          onClick={() => {
            navigate("/domesticstays/Details", { state: { SearchStay: Stay } });
          }}
        >
          {translations.PatientStaytableDetails}
        </button>
      ),
    };
  };

  const RefreshTable = (resList) => {
    const rows = resList.map((Entry) => MakeTableRow(Entry));
    setTableDataRows(rows);
    setIsLoaded(true);
    Swal.close(); // Close the loader once data is refreshed
  };

  useEffect(() => {
    if (Object.keys(ResponseData).length > 0) {
      RefreshTable(ResponseData.list);
    }
  }, [ResponseData]);

  useEffect(() => {
    if (Object.keys(ResponseData).length > 0) {
      setIsLoaded(true);
    } else {
      setIsLoaded(false);
    }
  }, [ResponseData]);

  const onSearch = async () => {
    SearchReq.pagingParams.pageNumber = Page;
    let res = await AccountingApi.SearchDomesticStays(SearchReq);

    if (res.status === "Success") {
      setResponseData(res.data);
      setTotalPages(res.data.totalPages);
    } else {
    }
  };

  useEffect(() => {
    onSearch();
  }, [SearchReq]);

  useEffect(() => {
    onSearch();
  }, [Page]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <StaySearch setSearchReq={setSearchReq} />
      {!IsLoaded && <Loader />}:
      {IsLoaded && (
        <Card className="mt-5">
          <MDBox
            mx={4}
            mt={-3}
            py={3}
            px={2}
            sx={{ backgroundColor: "#3560AD" }}
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
          >
            <div className="text-center">
              <MDTypography variant="h6" color="white">
                {translations.contactssearchContractDomesticStays}
              </MDTypography>
            </div>
          </MDBox>

          {/* Table content */}

          <DataTable
            table={{ columns: TableColumns, rows: TableDataRows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />

          <div className="text-right mx-3 my-4">
            <Pagination
              count={TotalPages}
              color="primary"
              onChange={(e, num) => setPage(num)}
              className="float-right"
            />
          </div>
        </Card>
      )}
    </DashboardLayout>
  );
};

export default Index;
